import moment from 'moment';

export const buildReportPayload = (sharedFilters, reportType, pageno, perpage = 10, includeFilters) => {
  const payload = {
    certificate_status: sharedFilters.certificate_status || [],
    course: sharedFilters.course || [],
    customer: sharedFilters.customer || [],
    project: sharedFilters.project || [],
    email: sharedFilters.email || '',
    pageno: pageno == null ? 0 : pageno,
    perpage,
    report_type: reportType,
  };
  if (typeof includeFilters === 'boolean') {
    payload.include_filters = includeFilters;
  }
  const range = sharedFilters.date_range || 'all_time';
  if (range === 'all_time') {
    return payload;
  }
  if (range === 'custom') {
    payload.date_range = 'custom';
    payload.date_from = sharedFilters.date_from;
    payload.date_to = sharedFilters.date_to;
    return payload;
  }
  payload.date_range = range;
  return payload;
};

export const formatAppliedPeriod = (dateRange) => {
  if (!dateRange) {
    return '';
  }
  if (!dateRange.date_from && !dateRange.date_to) {
    return 'All time';
  }
  const from = moment(dateRange.date_from, 'YYYY-MM-DD', true);
  const to = moment(dateRange.date_to, 'YYYY-MM-DD', true);
  const fromLabel = from.isValid() ? from.format('D MMM YYYY') : String(dateRange.date_from || '');
  const toLabel = to.isValid() ? to.format('D MMM YYYY') : String(dateRange.date_to || '');
  if (!fromLabel && !toLabel) {
    return 'All time';
  }
  const field = dateRange.date_field || 'course_assignment_date';
  const fieldLabel = field === 'course_assignment_date'
    ? 'by assignment date'
    : `by ${String(field).replace(/_/g, ' ')}`;
  return `${fromLabel} – ${toLabel} (${fieldLabel})`;
};
